// Lib
import React, { ReactElement } from 'react';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { compose } from '../../../node_module_clones/recompose';

// Selectors
import { mobileQuickNotesPageSelector } from '../header/workspaceToolsHeader/quickNotes/quickNotesSelector';
import { quickNotesElementSelector } from '../header/workspaceToolsHeader/quickNotes/quickNotesElementsSelector';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Components
import QuickNotesScrollableList from './QuickNotesScrollableList';
import PoiBoardSectionContext from '../../components/pointsOfInterest/PoiBoardSectionContext';
import LoadingSpinner from '../../components/loaders/Spinner';
import MobileQuickAddSheet from './MobileQuickAddSheet';
import useScaledList from '../../canvas/zoom/list/useScaledList';
import { ZoomStateContextProvider } from '../../canvas/zoom/ZoomStateContext';

// Constants
import { BoardSections } from '../../../common/boards/boardConstants';
import { GeneralWorkspaceProps } from '../workspaceTypes';

import './MobileQuickNotesPage.scss';
import elementShortcutsDecorator from '../shortcuts/clipboard/elementShortcutsDecorator';

const quickNotesElementSelectorConnector = connect(quickNotesElementSelector);
const quickNotesPageSelectorConnector = connect(mobileQuickNotesPageSelector);

type Props = GeneralWorkspaceProps &
    ConnectedProps<typeof quickNotesElementSelectorConnector> &
    ConnectedProps<typeof quickNotesPageSelectorConnector> & {
        createShortcutCard: (element: object) => void;
    };

const enhance = compose<Props, GeneralWorkspaceProps>(
    quickNotesElementSelectorConnector,
    quickNotesPageSelectorConnector,
    elementShortcutsDecorator,
);

const MobileQuickNotesPage = (props: Props): ReactElement => {
    const {
        quickNotesRootId,
        quickNotesChildIds,
        isCurrentBoardFetching,
        currentBoard,
        gridSize,
        permissions,
        createShortcutCard,
    } = props;

    const platformDetails = useSelector(getPlatformDetailsSelector);

    const { zoomScale, listStyle } = useScaledList(platformDetails, gridSize);

    if (isCurrentBoardFetching) {
        return (
            <div className="MobileQuickNotesPage">
                <LoadingSpinner show />
            </div>
        );
    }

    return (
        <>
            <div className="MobileQuickNotesPage">
                <PoiBoardSectionContext.Provider value={BoardSections.QUICK_NOTES}>
                    <ZoomStateContextProvider zoomScale={zoomScale}>
                        <div className="quick-notes-scrollable-list-container">
                            <QuickNotesScrollableList
                                gridSize={gridSize}
                                permissions={permissions}
                                quickNotesRootId={quickNotesRootId}
                                quickNotesChildIds={quickNotesChildIds}
                                listStyle={listStyle}
                                createShortcutCard={createShortcutCard}
                            />
                        </div>
                    </ZoomStateContextProvider>
                </PoiBoardSectionContext.Provider>
            </div>
            <MobileQuickAddSheet currentBoard={currentBoard} />
        </>
    );
};

export default enhance(MobileQuickNotesPage);
